import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportCard } from '@components/Pages/AnalyticsPage/ReportCard';
import { DateRangeField, type IDateRange } from '@components/ui/DateRangeField/DateRangeField';
import styles from './ScissorLiftExportCard.module.css';
import { CardIcon } from '../CardIcon';

interface IScissorLiftExportCardProps {
  isSelected: boolean;
  onSelect: (name: 'scissorLiftExport') => void;
}

export function ScissorLiftExportCard({ isSelected, onSelect }: IScissorLiftExportCardProps) {
  const { t } = useTranslation();
  const [range, setRange] = useState<IDateRange>({ from: null, to: null });
  const [exportRequested, setExportRequested] = useState(false);

  const canSubmit = range.from !== null && range.to !== null;

  return (
    <ReportCard
      name="scissorLiftExport"
      title={t('analytics.cards.scissorLiftExport.title')}
      description={t('analytics.cards.scissorLiftExport.description')}
      icon={<CardIcon name="scissors-lift" />}
      isSelected={isSelected}
      onSelect={() => onSelect('scissorLiftExport')}
      onSubmit={() => setExportRequested(true)}
      submitLabel={t('analytics.exportButton')}
      submitDisabled={!canSubmit}
    >
      <DateRangeField
        value={range}
        onChange={(r) => {
          setRange(r);
          setExportRequested(false);
        }}
        placeholder={t('analytics.filters.selectPlaceholder')}
        ariaLabel={t('analytics.filters.datePeriod')}
      />
      {exportRequested ? (
        <div role="status" className={styles.notice}>{t('analytics.scissorLiftSoon')}</div>
      ) : null}
    </ReportCard>
  );
}
